"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const csLocaleData = require("i18next-icu/locale-data/cs");
exports.default = csLocaleData;
//# sourceMappingURL=cs.js.map